<template>
  <div class="business-issuance-wrapper">
    <!-- 上栏查询 -->
    <query-bar
      :query="query"
      :services="services"
      :channels="channels"
      :companys="companys"
      @query="onClickQuery"
    />

    <!-- 数据列表 -->
    <list-data
      :list-data="listData"
      :loading="showLoading"
      ref="listdata"
      @checkboxData="getCheckboxData"
    />

    <!-- 全局组件分页 -->
    <common-page :page-data="pageData" @change="onChangePage">
      <template #right-aside>
        <button class="button margin-right" data-num="0" @click="publish">
          批量发行
        </button>
      </template>
    </common-page>

    <!-- 点击批量发行的弹窗 -->
    <common-dialog v-model="showDialog" @confirm="handleSubmitInfo">
      <template>
        <p class="title">
          批量发行
          <span class="total">{{ checkedList.length }}</span>
          个件
        </p>

      </template>
    </common-dialog>
  </div>
</template>

<script>
import queryPage from '@/mixins/queryPage'

import QueryBar from './components/QueryBar'
import ListData from './components/ListData'
export default {
  mixins: [queryPage],
  components: {
    QueryBar,
    ListData
  },

  data() {
    return {
      checkedList: [], // 复选框选中的id
      issueType: [], // 发行类型
      showDialog: false //是否显示弹框
    }
  },

  created() {
    // 获取所有下拉框字段值
    this.getCompanyList()
    this.getServiceList()
    this.getChannelList()
  },

  methods: {
    // 初始页面数据列表
    getListData() {
      const {
        query,
        $store: { dispatch },
        pageData: { currentPage, pageSize }
      } = this
      const dispatchEvent = 'T2/businessIssuance/getListData'

      return dispatch(dispatchEvent, {
        ...query,
        pageSize,
        currentPage
      }).then(res => {
        this.listData = res.list
        this.pageData.total = res.total
      })
    },

    // 选中的数据
    getCheckboxData(val) {
      this.checkedList = []
      val.map(item => {
        let type = { card: { merId: item.merId }, issueType: item.stateAudit }

        this.checkedList.push(type)
      })
    },

    // 批量发行
    publish() {
      console.log(this.checkedList)
      if (this.checkedList.length <= 0) {
        this.$alert.error('至少选择一个商户')
        return
      }
      this.showDialog = true
    },

    handleSubmitInfo() {
      const { dispatch } = this.$store
      const dispatchEvent = 'T2/businessIssuance/batchConfirm'

      dispatch(dispatchEvent, this.checkedList).then(res => {
        this.showDialog = false

        if (res.status === 200) {
          this.$alert('批量发行成功').then(_ => {
            this.$refs.listdata.$refs.multipleTable.clearSelection()
            this.getListData()
          })
        }
      })
    }
  }
}
</script>
